import React, { useContext, useEffect, useRef, useState } from "react";
import Header from "../components/header/Header";
import { useNavigate } from "react-router-dom";
import { useCookies } from "react-cookie";
import globalContext from "../Contexts/GlobalContext";
import useRequestHeader from "../hooks/useRequestHeader";
import DesktopView from "../components/desktopview/DesktopView";
import MessageModals from "../components/modals/MessageModals";
import MaskedInput from "react-text-mask";
import ColoredLoader from "../components/coloredLoader/ColoredLoader";
import { addCommas, p2e, removeNonNumeric } from "../utils/functions";
import { SERVERMODE } from "../constants/serverMode";
import { serverErrorMessage, SERVERMESSAGE } from "../constants/serverMessage";
import { handleServerMode } from "../utils/handleServer";
import axios from "axios";

export default function PayBill() {
  const BASE_URL = process.env.REACT_APP_ROOT_API_ADDRESS;
  const navigate = useNavigate();
  const [cookies, setCookies, removeCookies] = useCookies();
  const contextData = useContext(globalContext);
  const requestHeader = useRequestHeader();

  const [isLoadingPayBill, setIsLoadingPayBill] = useState(false);
  const [billMode, setBillMode] = useState("inquiry");

  const [billIDMemory, setBillIDMemory] = useState("");
  const [payIDMemory, setPayIDMemory] = useState("");
  const [billID, setBillID] = useState("");
  const [payID, setPayID] = useState("");
  const [billIDErr, setBillIDErr] = useState("");
  const [payIDErr, setPayIDErr] = useState("");
  const billIDRef = useRef();
  const payIDRef = useRef();

  const [paymentLink, setPaymentLink] = useState("");
  const [billAmount, setBillAmount] = useState("");
  const [billType, setBillType] = useState("");
  const [billDesc, setBillDesc] = useState("");

  useEffect(() => {
    if (
      billID != billIDMemory ||
      payID != payIDMemory ||
      paymentLink.length == 0
    ) {
      setBillMode("inquiry");
    } else {
      setBillMode("pay");
    }
  }, [billID, payID]);

  const inquiryPayBill = () => {
    if (!isLoadingPayBill) {
      if (checkInputs()) {
        if (billMode == "inquiry") {
          setIsLoadingPayBill(true);
          const config = {
            headers: requestHeader,
          };
          const reqBody = {};
          reqBody.billID = billID;
          reqBody.payID = payID;
          axios
            .post(`${BASE_URL}/inquiries/violation/payAndBill`, reqBody, config)
            .then((res) => {
              var responseMode = res?.data?.Mode;
              var responseMessage = res?.data?.Message;
              switch (responseMode) {
                case SERVERMODE.REQUEST_OK: {
                  if (res?.data?.Data?.PaymentLink) {
                    setPaymentLink(res?.data?.Data?.PaymentLink);
                  }
                  if (res?.data?.Data?.Bills?.Amount) {
                    setBillAmount(res?.data?.Data?.Bills?.Amount);
                  }
                  if (res?.data?.Data?.Bills?.BillTypeShowName) {
                    setBillType(res?.data?.Data?.Bills?.BillTypeShowName);
                  }
                  if (res?.data?.Data?.Bills?.Description) {
                    setBillDesc(res?.data?.Data?.Bills?.Description);
                  }
                  setBillMode("pay");
                  setBillIDMemory(billID);
                  setPayIDMemory(payID);
                  break;
                }
                case SERVERMODE.REQUEST_WRONG: {
                  contextData.setIsToastOpen(true);
                  contextData.setToastMessage(
                    SERVERMESSAGE.WRONG_PAY_AND_BILL_ID
                  );
                  break;
                }
                case SERVERMODE.REQUEST_ERROR: {
                  contextData.setIsToastOpen(true);
                  contextData.setToastMessage(serverErrorMessage());
                  break;
                }
                case SERVERMODE.SERVICE_NOT_ACTIVE: {
                  contextData.setIsToastOpen(true);
                  contextData.setToastMessage(SERVERMESSAGE.SERVICE_NOT_ACTIVE);
                  navigate("/payEst", { replace: true });
                  break;
                }
                default: {
                  handleServerMode(
                    responseMode,
                    responseMessage,
                    contextData,
                    cookies,
                    removeCookies,
                    navigate
                  );
                }
              }
              setIsLoadingPayBill(false);
            })
            .catch((err) => {
              contextData.setIsToastOpen(true);
              contextData.setToastMessage("ارتباط با سرور دچار مشکل شده است");
              setIsLoadingPayBill(false);
            });
        } else {
          window.open(paymentLink, "_self");
        }
      }
    }
  };

  const checkInputs = () => {
    let isOk = true;
    if (billID.replaceAll(" ", "").length == 0) {
      isOk = false;
      setBillIDErr("شناسه قبض نمی‌تواند خالی باشد");
    }
    if (payID.replaceAll(" ", "").length == 0) {
      isOk = false;
      setPayIDErr("شناسه پرداخت نمی‌تواند خالی باشد");
    }

    return isOk;
  };
  return (
    <>
      <div className="hidden min-[1024px]:block ">
        <DesktopView />
      </div>
      <div
        className="w-full h-screen flex flex-col items-center justify-between bg-[#153038] min-[1024px]:hidden "
        onClick={() => {}}
      >
        <Header relt="relative" />
        {contextData.isToastOpen && (
          <MessageModals
            setIsOpen={contextData.setIsToastOpen}
            message={contextData.toastMessage}
          />
        )}

        <div
          className={`w-full flex-1 flex flex-col items-start justify-start  gap-y-[2vw] overflow-y-auto px-[20px]`}
        >
          <div className="w-full flex flex-col items-center justify-center p-[2vw] mt-[12vw] gap-y-[1vw]">
            <p className="font-font_primary_A text-[5.5vw] text-white font-bold">
              پرداخت با شناسه
            </p>
            <p className="font-font_primary_A text-[3vw] text-white font-extralight">
              شناسه قبض و شناسه پرداخت را وارد نمایید
            </p>
          </div>

          <div className="w-full mt-[2vw]">
            <span className="w-full text-[3.5vw] text-color-primary-A font-font_primary_A">
              شناسه قبض:
            </span>

            <MaskedInput
              mask={[
                /[۰۱۲۳۴۵۶۷۸۹0-9]/,
                /[۰۱۲۳۴۵۶۷۸۹0-9]/,
                /[۰۱۲۳۴۵۶۷۸۹0-9]/,
                /[۰۱۲۳۴۵۶۷۸۹0-9]/,
                /[۰۱۲۳۴۵۶۷۸۹0-9]/,
                /[۰۱۲۳۴۵۶۷۸۹0-9]/,
                /[۰۱۲۳۴۵۶۷۸۹0-9]/,
                /[۰۱۲۳۴۵۶۷۸۹0-9]/,
                /[۰۱۲۳۴۵۶۷۸۹0-9]/,
                /[۰۱۲۳۴۵۶۷۸۹0-9]/,
                /[۰۱۲۳۴۵۶۷۸۹0-9]/,
                /[۰۱۲۳۴۵۶۷۸۹0-9]/,
                /[۰۱۲۳۴۵۶۷۸۹0-9]/,
              ]}
              guide={false}
              ref={billIDRef}
              value={billID}
              type="tel"
              className={`w-full h-[11vw] border-[1px] ${
                billIDErr ? "border-color-error" : "border-color-primary-D"
              } bg-transparent rounded-[1.8vw] text-center text-[5vw] focus:text-[5vw] font-font_primary_A focus:font-font_primary_A text-color-primary-A focus:text-color-primary-A outline-none mt-[2vw]`}
              onChange={(e) => {
                setBillID(e.target.value);
                setBillIDErr("");
                if (e.target.value.length === 13) {
                  billIDRef.current.inputElement.blur();
                }
              }}
            />
            <span className="w-full font-font_primary_A text-[2.8vw] text-color-error">
              {billIDErr}
            </span>
          </div>
          <div className="w-full mt-[2vw]">
            <span className="w-full text-[3.5vw] text-color-primary-A font-font_primary_A">
              شناسه پرداخت:
            </span>

            <MaskedInput
              mask={[
                /[۰۱۲۳۴۵۶۷۸۹0-9]/,
                /[۰۱۲۳۴۵۶۷۸۹0-9]/,
                /[۰۱۲۳۴۵۶۷۸۹0-9]/,
                /[۰۱۲۳۴۵۶۷۸۹0-9]/,
                /[۰۱۲۳۴۵۶۷۸۹0-9]/,
                /[۰۱۲۳۴۵۶۷۸۹0-9]/,
                /[۰۱۲۳۴۵۶۷۸۹0-9]/,
                /[۰۱۲۳۴۵۶۷۸۹0-9]/,
                /[۰۱۲۳۴۵۶۷۸۹0-9]/,
                /[۰۱۲۳۴۵۶۷۸۹0-9]/,
                /[۰۱۲۳۴۵۶۷۸۹0-9]/,
                /[۰۱۲۳۴۵۶۷۸۹0-9]/,
                /[۰۱۲۳۴۵۶۷۸۹0-9]/,
              ]}
              guide={false}
              ref={payIDRef}
              value={payID}
              type="tel"
              className={`w-full h-[11vw] border-[1px] ${
                payIDErr ? "border-color-error" : "border-color-primary-D"
              } bg-transparent rounded-[1.8vw] text-center text-[5vw] focus:text-[5vw] font-font_primary_A focus:font-font_primary_A text-color-primary-A focus:text-color-primary-A outline-none mt-[2vw]`}
              onChange={(e) => {
                setPayID(e.target.value);
                setPayIDErr("");
                if (e.target.value.length === 13) {
                  payIDRef.current.inputElement.blur();
                }
              }}
            />

            <span className="w-full font-font_primary_A text-[2.8vw] text-color-error">
              {payIDErr}
            </span>
          </div>
        </div>

        {billMode == "pay" && (
          <div className="w-full px-[20px] my-[2vw]">
            <div className="w-full rounded-[1.8vw] py-[3vw] px-[3vw] bg-[#204f5e]">
              {billType && (
                <div className="w-full flex items-center justify-between">
                  <span className="font-font_primary_A text-[3.5vw] text-color-primary-A">
                    نوع قبض:
                  </span>
                  <span className="font-font_primary_A text-[3.5vw] text-color-primary-A">
                    {billType}
                  </span>
                </div>
              )}

              <div className="w-full flex items-center justify-between mt-[3vw]">
                <span className="font-font_primary_A text-[3.5vw] text-color-primary-A">
                  مبلغ:
                </span>
                <div className="flex items-center justify-center gap-x-[1vw] font-font_primary_A text-[3.5vw] text-color-primary-A">
                  <span>{addCommas(removeNonNumeric(p2e(billAmount)))}</span>
                  <span>ریال</span>
                </div>
              </div>

              {billDesc && (
                <div className="w-full flex items-center justify-between mt-[3vw]">
                  <span className="font-font_primary_A text-[3.5vw] text-color-primary-A">
                    توضیحات:
                  </span>
                  <span className="font-font_primary_A text-[3.5vw] text-color-primary-A">
                    {billDesc}
                  </span>
                </div>
              )}
            </div>
          </div>
        )}

        <div
          className={`w-full  flex flex-col items-start justify-end  gap-y-[2vw] px-[20px]`}
        >
          <div className="w-full flex items-center justify-between text-[#FFF] font-font_primary_A my-[4vw] ">
            <button
              className="w-full h-[11vw] flex items-center justify-center border-[1px] text-[3vw] rounded-[1.8vw] border-color-primary-D text-color-primary-D"
              onClick={inquiryPayBill}
            >
              {isLoadingPayBill ? (
                <ColoredLoader size={30} color="#00F7FF" />
              ) : (
                <>
                  {billMode == "inquiry"
                    ? "استعلام"
                    : `پرداخت ${addCommas(removeNonNumeric(p2e(billAmount)))}`}
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
